<template>
  <div class="infoblock">
    <div class="header">{{ title }}</div>
    <div class="d-lg-flex gap-2">
      <div class="d-flex cabcard">
        <div class="photo">
          <img :src="photoSrc" v-if="photoSrc"/>
        </div>
        <div class="body">
          <div class="sub">
            <div><span class="icon users"></span>{{ capacity }}</div>
            <div><span class="icon area"></span>{{ area }} м²</div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="d-flex flex-wrap mt-3 mt-lg-0" v-if="Object.keys(bookingData).length">

          <template  v-for="(bData, index) in bookingMatrix" :key="index">
            <div v-if="index && isViewGap(bData.totalMinutes)">
              <div class="block-gap">
                ...
              </div>
            </div>
            <div >

            <button @click="this.openModalAddComment(bData)" class="hourBlock" :title="getTitle(bData.canCancel)" :class="{expired: !bData.canCancel, isArchive: archive }" >
              <div>
              <span class="block">{{ timeView1(bData) }}</span>
              -
              <span class="block">{{ timeView2(bData) }}</span>
              </div>
              <span class="comment-icon" v-if="bData.comment || bData.commentTenant">
                <span class="circle">
                  <span class="comments"></span>
                </span>

              </span>
            </button>
            </div>
            {{setActualView(bData.canCancel)}}
            {{ setTimeViewTotalMinutes(bData.totalMinutes) }}
          </template>
        </div>
        <div class="d-flex align-items-center  h-100" v-if="!Object.keys(bookingData).length">
          <div class="nobookings">
            Все брони отменены.
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 mt-lg-3" v-if="!archive && Object.keys(bookingData).length">
      <button @click="this.openModalSendList()" class="btn-send ext-nowrap me-1 mb-3 mb-lg-0">Отправить клиенту</button>
      <button @click="this.openModalCommentList()" class="btn-comment ext-nowrap me-1 mb-3 mb-lg-0">Комментарии</button>
      <button @click="this.openModalCancelBookings()" class="btn-cancel ext-nowrap me-1 mb-3 mb-lg-0">Отменить бронирование</button>
      <button v-if="!isFutureDate(date) && isActualView" @click="this.openModalChangeBookings()" class="btn-change ext-nowrap me-1 mb-3 mb-lg-0">Перенести бронирование</button>

      <router-link :to="{ name: 'view',query:{'finddate':date,'officeId':officeId},'hash':'#bookingtable'}"
                   class="btn-edit text-nowrap">Редактировать бронирование
      </router-link>
    </div>
  </div>


</template>

<script>
import {openModal} from "jenesius-vue-modal";
import CommentModal from "@/components/MyBookings/CommentModal.vue";
import CommentList from "@/components/MyBookings/CommentList.vue";
import SendList from "@/components/MyBookings/SendList.vue";
import CancelBookingsModalList from "@/components/MyBookings/CancelBookingsModalList.vue";
import ChangeBookingsModalList from "@/components/MyBookings/ChangeBookingsModalList.vue";

let lastViewTotalMinutes = -1;

export default {
  name: "CabinetCard",
  props: {
    archive:Boolean,
    date:String,
    officeId:String,
    officeAddress:String,
    cabData: {},
    bookingData: {},
  },
  data() {
    return {
      isActualView:false,
      bookingMatrix: [],
      bookingLinkIdToMinutes: {},
    }
  },
  mounted() {


    this.$emitter.on('mybookingCancelDone', (ids) => {
      for (let key in this.bookingData){
          if(ids.includes(this.bookingData[key]['id'])){
            delete this.bookingData[key];
          }
      }
      this.bookingMatrix = []
      this.biuldMatrix()

    })
    this.biuldMatrix()
  },
  created() {

  },
  computed: {
    title() {
      return this.cabData && 'title' in this.cabData ? this.cabData.title :'No title'
    },
    photoSrc() {
      return this.cabData && this.cabData.photoSrc ? this.cabData.photoSrc.thumb_url : ''
    },
    capacity() {
      return this.cabData ? this.cabData.capacity :''
    },
    area() {
      return this.cabData ? this.cabData.area :''
    },
  },
  methods:{
    isFutureDate(dateStr){ // проверка что дата из будущего
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Обнуляем время, чтобы сравнивать только даты
      const date = new Date(dateStr);
      date.setHours(0, 0, 0, 0); // Тоже обнуляем время
      return date > today; // true, если дата сегодня или в будущем
    },
    setTimeViewTotalMinutes(val) {
      lastViewTotalMinutes = val
    },
    setActualView(act) {
      if(!this.isActualView & act){
        this.isActualView = true
      }
    },
    isViewGap(currentMinutes) {
      return lastViewTotalMinutes + 30 != currentMinutes
    },
    biuldMatrix() {
      const minuteToNumber = (m) => (m === "1/2" ? 0 : 30);
      let b_link = {}
      for (const key in this.bookingData) {

        let b = this.bookingData[key]

        b['totalMinutes'] = b.hour * 60 + minuteToNumber(b.minute)

          this.bookingMatrix.push(b)
          this.bookingLinkIdToMinutes[b.id] = b['totalMinutes']
          b_link[b['totalMinutes']] = b.id

      }

      const timeLine = {};
      for (let minutes = 0; minutes < 1440; minutes += 30) {
        timeLine[minutes] = minutes in b_link ? b_link[minutes] : false
      }

      this.timeLineIndex = timeLine
    },
    timeView1(data) {
      return data.hour + ':' + data.minuteView;
    },
    timeView2(data) {
      let hour = data.minuteView == '30' ? data.hour + 1 : data.hour;
      let minute = data.minuteView == '30' ? '00' : '30';
      return hour + ':' + minute;
    },
    openModalCommentList(){
      const props = {bookingData: this.bookingData};
      openModal(CommentList, props)
    },
    openModalSendList(){
      const props = {
        bookingData: this.bookingData,
        cabinetData: this.cabData,
        officeAddress: this.officeAddress,
        date: this.date
      };
      openModal(SendList, props)
    },
    openModalCancelBookings(){
      const props = {
        bookingData: this.bookingData,
        cabinetData: this.cabData,
        date: this.date
      };
      openModal(CancelBookingsModalList, props)
    },
    openModalChangeBookings(){
      const props = {
        bookingData: this.bookingData,
        cabinetData: this.cabData,
        date: this.date
      };
      openModal(ChangeBookingsModalList, props)
    },
    openModalAddComment(data){
      const props = {data: data};
      openModal(CommentModal, props)
    },
    getTitle(canCancel){
      return canCancel ? 'Время актуально' : 'Время истекло'
    }
  }
}
</script>

<style scoped>

.block {
  display: block;
}

.nobookings{
  font-size: 0.9rem;
  background: #ffe4e4;
  padding: 0.2rem 0.7rem;
  border-radius: 4px;
  width: auto;
  display: inline-block;
  color: #6e0522;
}

.btn-xs {
  padding: 0.15rem 0.8rem;
  line-height: 1.5rem;
  font-size: .75rem;
}

.hourBlock {
  position: relative;
  border: 1px solid #e07a5f7a;
  padding: 0.5rem 0.5rem;
  border-radius: 5px;
  font-size: .9rem;
  margin-left: 5px;
  margin-bottom: 5px;
  display: inline-flex;
  align-items: center;
  color:#fff;
}




.hourBlock.expired{
  opacity: .5;
  background: #edf5f7;
  color: #333;
}
.hourBlock.expired.isArchive{
  opacity: .8;
}

.hourBlock.expired:before {
  content: "";
  border-bottom: 1px solid #ccc;
  position: absolute;
  top: 0px;
  left: 7px;
  width: 100%;
  height: 60%;
  transform: rotate(34deg);
}
/*.hourBlock.expired:after {*/
/*  content: "";*/
/*  border-bottom: 1px solid #ccc;*/
/*  position: absolute;*/
/*  top: 0px;*/
/*  left: -5px;*/
/*  width: 100%;*/
/*  height: 60%;*/
/*  transform: rotate(-40deg);*/
/*}*/

.hourBlock{
  position: relative;
  border: 1px solid #c7bbbb7a;
  padding: 0.5rem 0.5rem;
  border-radius: 5px;
  font-size: .9rem;
  margin-left: 5px;
  margin-bottom: 5px;
  display: inline-flex;
  align-items: center;

  background:#81b29a;
  transition: all ease .3s;
}


.hourBlock {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 4em;
  width: 4.2em;
  min-width: 4.2em;
  padding: 0.1rem 0.1rem;
  border-radius: 5px;
  font-size: .7em;
  line-height: 1em;
  align-items: center;
  color: #fff;
  background: #81b29a;
  justify-content: center;
  border: 1px solid #17573800;
  user-select: none;
}

.hourBlock:hover{
  background:#71a28a;
}

.infoblock {
  padding: 10px 0;
  border-bottom: 1px solid #f2f2e7;

}

.infoblock:first-child {
  border-top: 1px solid #f2f2e7;
  /*border-top: none;*/
}

/*.infoblock:last-child {*/
/*  !*border-top: 1px solid #f2f2e7;*!*/
/*  !*border-bottom: none;*!*/
/*}*/
.cabcard{
  align-items: center
}
.cabcard .sub .icon {
  background-size: 100%;
  top: 2px;
  width: .75rem;
  height: .75rem;
}

.cabcard .body .sub {
  /*margin-top: 2px;*/
  min-width: 70px;
  font-size: .75rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /*align-items: center;*/
}

.cabcard .body .sub > * {
  margin-right: .5rem;
}

.cabcard .body {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  margin-left: .5rem;
}

.cabcard .photo {
  display: flex;
  align-items: center;
  flex-direction: row;
  background: #c9c9c9;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;

}

.cabcard .photo img {
  display: block;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;
  position: relative;

}

 .header {
  font-size: .85rem;
  margin-bottom: .5rem;
  padding-bottom: .5rem;
  color: #bb892a;
  font-weight: 700;
  border-bottom: 1px solid #f2f2e7;
}


.cabcard .sub .icon {
  background-size: 100%;
  top: 2px;
  width: .75rem;
  height: .75rem;
}

.cabcard .sub .icon.users {
  background-size: 119%;
  top: 4px;
  width: 1rem;
  height: 1rem;

}


/** ICON */
.icon {
  position: relative;
  display: inline-block;
  width: 1rem;
  /*height: 1rem;*/
  background-repeat: no-repeat;
  background-position: bottom;
  margin-right: .3rem;

}
.comment-icon{
  position: absolute;
  right: 0;
  top:-5px;
}
.comment-icon .circle{
  display: flex;
  border-radius: 50%;
  padding: 1px;
  background-color: #81b29a;
}
.comments {
  position: relative;
  display: block;
  width: 0.9em;
  height: 0.9em;
  background-size: contain;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23fff' class='bi bi-chat-text' viewBox='0 0 16 16'%3E%3Cpath d='M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894m-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z'/%3E%3Cpath d='M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5'/%3E%3C/svg%3E");

}
  .icon.users {
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.166 20C14.7559 20 17.666 17.0899 17.666 13.5C17.666 9.91015 14.7559 7 11.166 7C7.57616 7 4.66602 9.91015 4.66602 13.5C4.66602 17.0899 7.57616 20 11.166 20Z' stroke='%23E07A5F' stroke-width='2' stroke-miterlimit='10'/%3E%3Cpath d='M19.5911 7.2375C20.1657 7.08166 20.7582 7.00181 21.3536 7C23.0775 7 24.7308 7.68482 25.9498 8.90381C27.1687 10.1228 27.8536 11.7761 27.8536 13.5C27.8536 15.2239 27.1687 16.8772 25.9498 18.0962C24.7308 19.3152 23.0775 20 21.3536 20' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M2.16602 24.675C3.18095 23.2307 4.52856 22.0519 6.09503 21.2381C7.66149 20.4243 9.40079 19.9995 11.166 19.9995C12.9312 19.9995 14.6705 20.4243 16.237 21.2381C17.8035 22.0519 19.1511 23.2307 20.166 24.675' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M21.3535 20C23.1189 19.9989 24.8585 20.4232 26.4252 21.237C27.9918 22.0508 29.3393 23.2301 30.3535 24.675' stroke='%23E07A5F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
}

.icon.area {
  margin-top: 3px;
  background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23E07A5F' class='bi bi-arrows-fullscreen' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z'/%3E%3C/svg%3E");
}
.block-gap {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.3rem;
}
</style>